var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',{attrs:{"label":_vm.tradeEngineEnabled ? "Enabled" : "Disabled","disabled":_vm.api_form.api_key === '' && _vm.api_form.api_secret === ''},model:{value:(_vm.tradeEngineEnabled),callback:function ($$v) {_vm.tradeEngineEnabled=$$v},expression:"tradeEngineEnabled"}})}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31dabf2c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/settings/TradeEngineSwitch.vue
// module id = JJiM
// module chunks = 0